export default class LazyLoadImage {

  static init() {
    let io = new IntersectionObserver((entries ) => {
      entries.forEach(entry => {
        let target = entry.target;
        let src = target.getAttribute('src');
        let dataSrc = target.getAttribute('data-src');
        if (entry.isIntersecting && src !== dataSrc) {
          target.setAttribute('src', dataSrc);
        }
      });
    });

    if(window.jQuery && $('img.aw-lazy').length > 0){
      $( 'img.aw-lazy' ).each(( index, el ) => {
        io.observe(el);
      });
    }
    
  }

}
